import PropTypes from "prop-types";
import { Stack, SvgIcon, Typography, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MediaInfo = (props) => {
  const { infoList } = props;
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1.5}
      useFlexGap
      sx={{
        flexWrap: "wrap",
        alignItems: "center"
      }}>
      {infoList.map(
        (item) =>
          item.value !== null && (
            <Stack
              direction="row"
              spacing={0.4}
              sx={{ alignItems: "center" }}
              key={item.key}
            >
              <SvgIcon sx={{ fontSize: 11, color: theme.palette.text.disabled }}>
                <FontAwesomeIcon icon={item.icon} />
              </SvgIcon>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                {item.value}
              </Typography>
            </Stack>
          )
      )}
    </Stack>
  );
};

MediaInfo.propTypes = {
  infoList: PropTypes.array.isRequired,
};
